import React, { useState } from 'react';
import { Box, Typography, Button, TextField } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';
import { COLORS } from '../styles';

function EndRunScreen({ driver, downloadCounts, onAcknowledge, onSaveNote }) {
  const flights = driver?.flights || [];
  const totalBags = flights.reduce((t, f) => t + (downloadCounts[f.uniqueId] || 0), 0);
  const totalStops = flights.length;
  const [note, setNote] = useState('');

  const finish = () => {
    const trimmed = note.trim();
    if (trimmed) onSaveNote?.(trimmed);
    onAcknowledge();
  };

  return (
    <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column', p: 2 }}>
      {/* Success header */}
      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', mt: 1 }}>
        <Box sx={{
          width: 70, height: 70, borderRadius: '50%',
          backgroundColor: 'rgba(34, 197, 94, 0.18)',
          border: `2px solid ${COLORS.success}`,
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          mb: 1.5,
        }}>
          <CheckCircleIcon sx={{ color: COLORS.success, fontSize: 44 }} />
        </Box>
        <Typography sx={{ fontSize: '1.2rem', color: COLORS.textPrimary, fontWeight: 700, textAlign: 'center' }}>
          Run Complete
        </Typography>
        <Typography sx={{ fontSize: '0.75rem', color: COLORS.textSecondary, textAlign: 'center', mt: 0.25 }}>
          Nice work.
        </Typography>
      </Box>

      {/* Stats */}
      <Box sx={{ display: 'flex', gap: 1.25, mt: 2, width: '100%' }}>
        <SummaryTile label="Stops" value={totalStops} />
        <SummaryTile label="Bags" value={totalBags} />
        <SummaryTile label="Mins" value="38" />
      </Box>

      {/* Run notes */}
      <Box sx={{ mt: 2.5 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, mb: 0.6 }}>
          <ChatBubbleOutlineIcon sx={{ color: COLORS.accent, fontSize: 14 }} />
          <Typography sx={{
            fontSize: '0.65rem',
            color: COLORS.accent,
            fontWeight: 700,
            textTransform: 'uppercase',
            letterSpacing: 0.6,
          }}>
            Anything to Flag for Dispatch?
          </Typography>
        </Box>
        <TextField
          value={note}
          onChange={(e) => setNote(e.target.value)}
          placeholder="Equipment issue, delay, missing bag, anything dispatch should know…"
          multiline
          rows={3}
          fullWidth
          sx={{
            '& .MuiOutlinedInput-root': {
              backgroundColor: COLORS.surface,
              color: COLORS.textPrimary,
              fontSize: '0.78rem',
              '& fieldset': { borderColor: COLORS.divider },
              '&:hover fieldset': { borderColor: COLORS.accentDim },
              '&.Mui-focused fieldset': { borderColor: COLORS.accent },
            },
          }}
        />
        <Typography sx={{ fontSize: '0.6rem', color: COLORS.textMuted, mt: 0.4, fontStyle: 'italic' }}>
          Optional — dispatcher will see this before escalating.
        </Typography>
      </Box>

      {/* Action */}
      <Button
        onClick={finish}
        sx={{
          mt: 2,
          backgroundColor: COLORS.accent,
          color: '#0a1020',
          fontWeight: 700,
          py: 1.4,
          fontSize: '0.85rem',
          '&:hover': { backgroundColor: COLORS.accentDim },
        }}
      >
        Complete Run
      </Button>
    </Box>
  );
}

function SummaryTile({ label, value }) {
  return (
    <Box sx={{
      flex: 1,
      backgroundColor: COLORS.surface,
      borderRadius: 1.5,
      p: 1.25,
      textAlign: 'center',
    }}>
      <Typography sx={{ color: COLORS.accent, fontSize: '1.4rem', fontWeight: 800, lineHeight: 1 }}>
        {value}
      </Typography>
      <Typography sx={{ color: COLORS.textMuted, fontSize: '0.6rem', textTransform: 'uppercase', letterSpacing: 0.5, mt: 0.5 }}>
        {label}
      </Typography>
    </Box>
  );
}

export default EndRunScreen;
